import React from 'react';
import { AppContext } from './AppContext';

export const withTheme = (Component: any) => ({ ...props }) => (
  <AppContext.Consumer>{theme => <Component {...props} theme={theme} />}</AppContext.Consumer>
);
